import { render } from "./AuthGate.vue?vue&type=template&id=3c49c77b&scoped=true"
import script from "./AuthGate.vue?vue&type=script&lang=js"
export * from "./AuthGate.vue?vue&type=script&lang=js"

import "./AuthGate.vue?vue&type=style&index=0&id=3c49c77b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c49c77b"]])

export default __exports__